// src/pages/JoinUs.js
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import "./JoinUs.css";

const JoinUs = () => {
  return (
    <div className="joinus-page">
      <Navbar />

      {/* CENTERED MAIN CONTENT */}
      <div className="joinus-center-wrapper">
        <motion.div
          className="joinus-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="join-title">Join Us in Our Mission</h1>
          <div className="join-underline"></div>

          <p className="join-desc">
            Whether you're looking to secure your healthcare data or explore careers,
            Sapiencia.AI welcomes mission-driven individuals and organizations who want
            to make an impact.
          </p>

          <div className="join-buttons">
            <a href="/contact" className="cta-button">Contact Us</a>
            <a href="/careers" className="outline-button">Explore Careers</a>
          </div>
        </motion.div>
      </div>

      {/* FIXED FOOTER AT BOTTOM */}
      <Footer />
    </div>
  );
};

export default JoinUs;
